export default {
  namespace: true,
  state: {
    menus: {}
  },
  mutations: {
    SET_MENU_MERGE: function SET_MENU_MERGE(state, payload) {
      var t = {};
      t[payload.type] = payload.value;
      var o = Object.assign({}, state.menus, t);
      state.menus = o;
    }
  },
  actions: {},
  getters: {
    getMenuByType: function getMenuByType(state) {
      var menus = state.menus;
      return function (type) {
        return menus[type];
      };
    }
  }
};